import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#B42318"
      fillRule="evenodd"
      d="M10.548 2.196a.625.625 0 0 0-1.093 0l-8.333 15a.625.625 0 0 0 .546.929h16.667a.625.625 0 0 0 .546-.928l-8.333-15ZM9.376 13.75V15h1.25v-1.25h-1.25Zm1.25-1.25V8.333h-1.25V12.5h1.25Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
